<section class="container">
    <div class="header-wrapper">
        <h1 data-qa-id="maintenance-tasks-header">Maintenance Tasks</h1>
    </div>
    <div class="content-wrapper">
        <mat-form-field appearance="outline" style="width: 55vw">
            <mat-label>Maintenance tasks to perform against this tenant</mat-label>
            <input data-qa-id="maintenance-tasks-input-filter" [(ngModel)]="tasksFilter" [name]="'filter'" [placeholder]="'Search'" aria-label="Search maintenance tasks" matInput type="text"/>
        </mat-form-field>
    </div>
</section>

@if (busy) {
    <div class="loading-image-container">
        <div class="loading-image small"></div>
        <div class="loading-text">{{ busyMessage }}</div>
    </div>
}

<mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="All"></mat-tab>
    @for (category of taskCategories(); track category) {
        <mat-tab label="{{category}}"></mat-tab>
    }
</mat-tab-group>

@for (task of filteredTasks(tasksFilter, activeTabName); track task.Id) {
    <mat-card>
        <mat-card-title>
            {{ task.Name }}
            <mat-chip-set class="category-chips">
                @for(cat of task.Categories; track cat) {
                    <mat-chip class="category-chip category-chip--{{cat.toLowerCase()}}" disableRipple>{{ cat }}</mat-chip>
                }
                @if (task.JiraTicket){
                    <a [href]="'https://ecoonline.atlassian.net/browse/' + task.JiraTicket" target="_blank" rel="noopener noreferrer" style="display:flex; cursor:pointer">
                        <mat-chip class="jira-chip" disableRipple>
                            <mat-icon>open_in_new</mat-icon>{{ task.JiraTicket }}
                        </mat-chip>
                    </a>
                }
            </mat-chip-set>
        </mat-card-title>

        @if (task.Description) {
            <mat-card-content>
                <p class="preserve-newlines">{{ task.Description }}</p>
            </mat-card-content>
        }
        <mat-card-content>
            <mat-accordion class="example-headers-align" multi>

                <mat-expansion-panel (opened)="getHistory(task)">
                    <mat-expansion-panel-header>
                        <mat-panel-title>History</mat-panel-title>
                        <mat-panel-description>
                            Previous Runs
                            <mat-icon>history</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    @if (task.history) {
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>User</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (run of task.history; track run.JobId) {
                                    <tr>
                                        <td>{{ run.DateStarted }}</td>
                                        <td>{{ run.User }}</td>
                                        <td>{{ run.Status }}</td>
                                        <td>
                                            <button (click)="task.provisioningJob = run.JobId" color="primary" mat-button>
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                </mat-expansion-panel>

                <mat-expansion-panel #panel="matExpansionPanel" (closed)="task.showRunConfig = false;"
                                     (opened)="toggleShowConfig(task)">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Configure And Run</mat-panel-title>
                        <mat-panel-description>
                            Run this job ({{ task.ExecutionType }})
                            <mat-icon>play_circle_outline</mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    @if (task.showRunConfig && hasConfig(task)) {
                        <form #settingsForm="ngForm"
                              (ngSubmit)="onSubmit(task, settingsForm); settingsForm.form.valid && panel.expanded = false;"
                              [id]="task.ClassName+'form'">
                            @if (task.Instructions) {
                                <mat-panel-description style="margin-bottom:16px">{{ task.Instructions }}</mat-panel-description>
                            }
                            @for (setting of task.EditModel.PropertyEditModels; track setting.PropertyName) {
                                <div>
                                    @if (setting.ControlType === 'text') {
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ setting.Label | pascalToHuman}}</mat-label>
                                            <input [(ngModel)]="task.RunConfig[setting.PropertyName]"
                                                   [name]="task.ClassName+setting.PropertyName" [placeholder]="setting.Label"
                                                   [required]="setting.Mandatory" [attr.aria-label]="setting.Label" matInput type="text"/>
                                        </mat-form-field>
                                        <br/>
                                    }
                                    @if (setting.ControlType === 'integer') {
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ setting.Label | pascalToHuman}}</mat-label>
                                            <input [(ngModel)]="task.RunConfig[setting.PropertyName]"
                                                   [name]="task.ClassName+setting.PropertyName" [placeholder]="setting.Label"
                                                   [required]="setting.Mandatory" [attr.aria-label]="setting.Label" matInput step="1" type="number"/>
                                        </mat-form-field>
                                        <br/>
                                    }
                                    @if (setting.ControlType === 'textarea') {
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ setting.Label | pascalToHuman}}</mat-label>
                                            <textarea [(ngModel)]="task.RunConfig[setting.PropertyName]"
                                                      [name]="task.ClassName+setting.PropertyName"
                                                      [placeholder]="setting.Label" [required]="setting.Mandatory"
                                                      matInput></textarea>
                                        </mat-form-field>
                                        <br/>
                                    }
                                    @if (setting.ControlType === 'boolean') {
                                        <mat-checkbox [(ngModel)]="task.RunConfig[setting.PropertyName]"
                                                      [name]="task.ClassName+setting.PropertyName" [required]="setting.Mandatory">
                                            {{ setting.Label | pascalToHuman }}
                                        </mat-checkbox>
                                        <br/><br/>
                                    }
                                    @if (setting.ControlType === 'password') {
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ setting.Label | pascalToHuman}}</mat-label>
                                            <input [(ngModel)]="task.RunConfig[setting.PropertyName]"
                                                   [name]="task.ClassName+setting.PropertyName" [placeholder]="setting.Label"
                                                   [required]="setting.Mandatory" [attr.aria-label]="setting.Label" matInput type="password"/>
                                        </mat-form-field>
                                        <br/>
                                    }
                                    @if (setting.ControlType === 'dropdown') {
                                        <mat-form-field appearance="outline" class="dropdown-field">
                                            <mat-label>{{ setting.Label | pascalToHuman}}</mat-label>
                                            <mat-select [(ngModel)]="task.RunConfig[setting.PropertyName]"
                                                        [name]="task.ClassName+setting.PropertyName" [placeholder]="setting.Label"
                                                        [required]="setting.Mandatory">
                                                <mat-option [value]="null"></mat-option>
                                                @for (val of setting.Values; track val) {
                                                    <mat-option [value]="val">{{ val | pascalToHuman}}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                        <br/>
                                    }
                                    @if (setting.ControlType === 'radiobutton') {
                                        <label [for]="task.ClassName + setting.PropertyName">{{ setting.Label | pascalToHuman }}</label>
                                        <br/>
                                        <mat-radio-group [(ngModel)]="task.RunConfig[setting.PropertyName]"
                                                         [id]="task.ClassName + setting.PropertyName"
                                                         [name]="task.ClassName+setting.PropertyName"
                                                         [required]="setting.Mandatory">
                                            @for (val of setting.Values; track val) {
                                                <mat-radio-button [value]="val" style="margin-right: 16px;">
                                                    {{ val | pascalToHuman }}
                                                </mat-radio-button>
                                            }
                                        </mat-radio-group>
                                        <br/><br/>
                                    }
                                    @if (setting.ControlType === 'dictionary') {
                                        <span>{{ setting.Label | pascalToHuman }}</span>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Key</th>
                                                    <th>Value</th>
                                                    <th>Options</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                @for (key of generateDictionary(task.RunConfig, setting.PropertyName); track key) {
                                                    <tr>
                                                        <td>{{ key }}</td>
                                                        <td>
                                                            <mat-form-field appearance="fill">
                                                                <input [(ngModel)]="task.RunConfig[setting.PropertyName][key]"
                                                                       [name]="'dictionaryProperty_'+key" [attr.aria-label]="'Dictionary value for ' + key" matInput/>
                                                            </mat-form-field>
                                                        </td>
                                                        <td>
                                                            <a (click)="removeRow(task.RunConfig[setting.PropertyName], key)"
                                                               id="maintenace-editor-delete-row-item-{{key}}" mat-button>
                                                                <mat-icon>delete</mat-icon>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <td>
                                                        <mat-form-field floatLabel="never">
                                                            <input [(ngModel)]="setting.newKey" id="newDictionaryKeyInput" matInput name="newDictionaryKey" aria-label="New dictionary key"/>
                                                        </mat-form-field>
                                                    </td>
                                                    <td>
                                                        <mat-form-field floatLabel="never">
                                                            <input [(ngModel)]="setting.newValue" id="newDictionaryValueInput" matInput name="newDictionaryValue" aria-label="New dictionary value"/>
                                                        </mat-form-field>
                                                    </td>
                                                    <td>
                                                        <a (click)="newValuePair(task.RunConfig[setting.PropertyName], setting.newKey, setting.newValue, setting)"
                                                           class="mat-accent" mat-raised-button>
                                                            &nbsp;<mat-icon>add</mat-icon>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br/>
                                    }
                                    @if (setting.ControlType === 'stringarray') {
                                        <span>{{ setting.Label | pascalToHuman }}</span>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Key</th>
                                                    <th>Options</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                @for (s of generateArray(task.RunConfig, setting.PropertyName); track $index) {
                                                    <tr>
                                                        <td>{{ s }}</td>
                                                        <td>
                                                            <a (click)="removeRow(task.RunConfig[setting.PropertyName], s)"
                                                               id="maintenace-editor-delete-row-item-{{s}}" mat-button>
                                                                <mat-icon>delete</mat-icon>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <td>
                                                        <mat-form-field floatLabel="never">
                                                            <input [(ngModel)]="setting.newItem" id="newArrayItemInput" matInput name="newArrayitem" aria-label="New array item"/>
                                                        </mat-form-field>
                                                        <a (click)="newArrayItem(task.RunConfig[setting.PropertyName], setting.newItem, setting)"
                                                           class="mat-accent" mat-raised-button>
                                                            &nbsp;<mat-icon>add</mat-icon>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br/>
                                    }
                                    @if (setting.ControlType === 'upload') {
                                        <span>{{ setting.Label | pascalToHuman }}</span>
                                        @if (task.CsvTemplateFileName) {
                                            <button (click)="downloadTemplate(task)" class="download-template-button" mat-stroked-button type="button">
                                                <mat-icon>download</mat-icon>
                                                Download Template
                                            </button>
                                        }
                                        <a (click)="fileInput.click()" id="maintenance-editor-upload" mat-stroked-button>
                                            <mat-icon>upload</mat-icon>
                                            Upload File
                                        </a>
                                        <span>{{ filenameToDisplay }}</span>
                                        <input #fileInput (change)="upload($event, task)" [accept]="getAcceptedFileTypes(setting)"
                                               hidden id="fileInput" [attr.aria-label]="'Upload file for ' + setting.Label" type="file"/>
                                        <br/>
                                    }
                                    @if (setting.ControlType === 'datepicker') {
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ setting.Label | pascalToHuman}}</mat-label>
                                            <input [(ngModel)]="task.RunConfig[setting.PropertyName]"
                                                   [name]="task.ClassName+setting.PropertyName"
                                                   [ngModel]="task.RunConfig[setting.PropertyName] | date: 'yyyy-MM-dd'"
                                                   [required]="setting.Mandatory" [attr.aria-label]="setting.Label | pascalToHuman" matInput type="date">
                                            <mat-hint>DD/MM/YYYY</mat-hint>
                                        </mat-form-field>
                                        <br/>
                                    }
                                    @if (setting.ControlType === 'modulepicker') {
                                        <mat-form-field appearance="outline">
                                            <mat-label>{{ setting.Label | pascalToHuman }}</mat-label>
                                            <mat-select [(ngModel)]="task.RunConfig[setting.PropertyName]"
                                                        [name]="task.ClassName+setting.PropertyName"
                                                        [placeholder]="setting.Label | pascalToHuman" [required]="setting.Mandatory">
                                                @if (!setting.Mandatory) {
                                                    <mat-option [value]="null"></mat-option>
                                                }
                                                @for (module of modules; track module.UniqueId) {
                                                    <mat-option [value]="module.UniqueId">{{ module.UniqueId }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                        <br/>
                                    }
                                </div>
                            }
                        </form>
                    }
                    <mat-action-row>
                        @if (hasConfig(task)) {
                            <button [attr.form]="task.ClassName+'form'" color="accent" mat-raised-button type="submit">Run Now</button>
                        }
                        @if (!hasConfig(task)) {
                            <button (click)="onSubmit(task); panel.expanded=false;" color="accent" id="run-task-button" mat-raised-button>Run Now</button>
                        }
                    </mat-action-row>
                </mat-expansion-panel>

            </mat-accordion>

            @if (task.provisioningJob) {
                <h4>
                    Run Log
                    <button (click)="task.provisioningJob = null" id="run-log-button" mat-icon-button>
                        <mat-icon>close</mat-icon>
                    </button>
                </h4>
                <job-liveview [jobId]="task.provisioningJob"></job-liveview>
            }

        </mat-card-content>

        <mat-card-actions>
        </mat-card-actions>

    </mat-card>
}
